import classNames from 'classnames';
import { useContext } from 'react';

import { BrandContext } from 'context/BrandContext';
import style from 'styles/components/common/Loading';

const Loading = ({ className = '' }) => {
  const { brand } = useContext(BrandContext);

  return (
    <div data-testid="loading" className={classNames(style.container, className)}>
      <i className={`${style.spinner} ${style[`spinner--${brand}`]}`}>
        <span className="sr-only">Loading...</span>
      </i>
    </div>
  );
};

Loading.propTypes = {
  className: PropTypes.string,
};

export default Loading;
